import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const FloatingTabBar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === "/";
  const isProfile = location.pathname === "/profile";

  // Hide when a WebView/iframe is open (dispatched by Dashboard)
  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    const hide = () => setHidden(true);
    const show = () => setHidden(false);
    window.addEventListener("webViewOpen", hide);
    window.addEventListener("webViewClose", show);
    return () => {
      window.removeEventListener("webViewOpen", hide);
      window.removeEventListener("webViewClose", show);
    };
  }, []);

  if (hidden) return null;

  const handleFAB = () => {
    if (isHome) {
      window.dispatchEvent(new CustomEvent("triggerLoanApplication"));
    } else {
      navigate("/");
    }
  };

  const tabBtn = (active: boolean): React.CSSProperties => ({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: "6px",
    paddingBottom: "6px",
    backgroundColor: active ? "rgba(255,255,255,0.95)" : "transparent",
    borderRadius: "20px",
    border: "none",
    cursor: "pointer",
    gap: "3px",
  });

  return (
    <div
      style={{
        position: "fixed",
        bottom: "10px",
        left: "50%",
        transform: "translateX(-50%)",
        width: "calc(100% - 10px)",
        maxWidth: "390px",
        zIndex: 100,
        paddingLeft: "5px",
        paddingRight: "5px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          backgroundColor: "rgba(234, 240, 239, 0.85)",
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)",
          borderRadius: "30px",
          paddingTop: "6px",
          paddingBottom: "6px",
          paddingLeft: "8px",
          paddingRight: "8px",
          alignItems: "center",
          justifyContent: "space-around",
          height: "63px",
          border: "1.5px solid #D6D6DA",
          boxShadow: "0 8px 24px rgba(0,0,0,0.18)",
        }}
      >
        {/* Home Tab */}
        <button onClick={() => navigate("/")} style={tabBtn(isHome)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill={isHome ? "none" : "none"}
            stroke={isHome ? "#00A86B" : "#2B2B2B"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            width="22"
            height="22"
          >
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
          </svg>
          <span
            style={{
              fontSize: "10px",
              color: isHome ? "#00A86B" : "#2B2B2B",
              fontWeight: "500",
              fontFamily: "DM Sans, sans-serif",
            }}
          >
            Home
          </span>
        </button>

        {/* FAB — ₹ button, elevated above tab bar */}
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "-45px",
          }}
        >
          <button
            onClick={handleFAB}
            style={{
              width: "62px",
              height: "62px",
              borderRadius: "31px",
              backgroundColor: "#07786B",
              border: "2px solid rgba(6, 122, 105, 0.75)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              boxShadow: "3px 3px 12px rgba(0,0,0,0.45)",
            }}
            aria-label="Quick Apply"
          >
            <span
              style={{
                fontSize: "26px",
                fontWeight: "300",
                color: "#FFFFFF",
                lineHeight: 1,
              }}
            >
              ₹
            </span>
          </button>
        </div>

        {/* Profile Tab */}
        <button onClick={() => navigate("/profile")} style={tabBtn(isProfile)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke={isProfile ? "#00A86B" : "#2B2B2B"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            width="22"
            height="22"
          >
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
          <span
            style={{
              fontSize: "10px",
              color: isProfile ? "#00A86B" : "#2B2B2B",
              fontWeight: "500",
              fontFamily: "DM Sans, sans-serif",
            }}
          >
            Profile
          </span>
        </button>
      </div>
    </div>
  );
};

export default FloatingTabBar;
